
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingPages/HomePage",
      function () {
        return require("private-next-pages/landingPages/HomePage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingPages/HomePage"])
      });
    }
  